import React, { Fragment, useEffect, useState } from "react";
import "./index.css";
import { Button, Result, Spin } from "antd";
import { Loading } from "../../../domain";
import { Endpoints, HttpClient } from "../../../infrastructure";
import { ServiceLocater, Services } from "../../../service-locater";
import { useQuery } from "../../hooks";
import { Link } from "react-router-dom";

export default function VerifyPayment() {
  const query = useQuery();
  const [loading, setLoading] = useState<Loading | "networkError">("idle");

  const status = query.get("Status");
  const authority = query.get("Authority");

  const verifyPayment = async (status: string, authority: string) => {
    setLoading("pending");
    try {
      await ServiceLocater.get<HttpClient>(
        Services.HttpClinet
      ).post(Endpoints.verifyPayment, { status, authority });
      setLoading("succeeded");
    } catch (error) {
      if (!error.response) setLoading("networkError");
      else setLoading("failed");
    }
  };

  useEffect(() => {
    if (status !== null && authority !== null) verifyPayment(status, authority);
  }, [status, authority]);

  return (
    <div className="verify-payment-center">
      <Spin spinning={loading === "idle" || loading === "pending"}>
        {loading === "idle" || loading === "pending" ? (
          <Fragment />
        ) : loading === "succeeded" ? (
          <Result
            status="success"
            title="ثبت موفق"
            subTitle="سفارش شما با موفقیت ثبت گردید. وضعیت سفارش خود را میتوانید از صفحه سفار ش ها در پروفایل بررسی کنید."
            extra={[
              <Link to="/profile/orders/?activeTab=paid">
                <Button type="primary">بازگشت</Button>
              </Link>,
            ]}
          />
        ) : loading === "failed" ? (
          <Result
            status="error"
            title="پرداخت ناموفق"
            subTitle="متأسفانه پرداخت شما از سمت بانک ناموفق بود. در صورتی که مبلغ از حساب شما کم شده است تا حداکثر ۷۲ ساعت آینده به حساب شما باز خواهد گشت."
            extra={[
              <Link to="/profile/orders/?activeTab=pending">
                <Button type="primary">بازگشت</Button>
              </Link>,
            ]}
          />
        ) : (
          <Result
            status="warning"
            subTitle="مشکلی در ارتباط با سرور به وجود آمد. لطفا اتصال اینترنت خود را بررسی و صفحه را دوباره بارگذاری نمایید."
          />
        )}
      </Spin>
    </div>
  );
}
